import React from 'react';
import { Provider } from 'react-redux';

import store from './src/state/createStore';

// eslint-disable-next-line react/display-name,react/prop-types
export default function wrapProvider({ element }) {
  return <Provider store={store}>{element}</Provider>;
}
